module.exports = __webpack_public_path__ + "img/ic_16_check_large.2cc8c384.svg";